import { render, staticRenderFns } from "./CdNote.vue?vue&type=template&id=1ae21b46&scoped=true&"
import script from "./CdNote.vue?vue&type=script&lang=js&"
export * from "./CdNote.vue?vue&type=script&lang=js&"
import style0 from "./CdNote.vue?vue&type=style&index=0&id=1ae21b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae21b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae21b46')) {
      api.createRecord('1ae21b46', component.options)
    } else {
      api.reload('1ae21b46', component.options)
    }
    module.hot.accept("./CdNote.vue?vue&type=template&id=1ae21b46&scoped=true&", function () {
      api.rerender('1ae21b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atomicUIComponents/note/CdNote.vue"
export default component.exports